<template>
    <div class="content-wrapper app-listing-page">
        <div class="row align-items-start mb-4">
            <div class="col-lg-8">
                <app-breadcrumb :page-title="$t('leave-types')" :icon="'grid'" />
                <p class="app-listing-page__intro text-muted mb-0">
                    {{ $t('leave_types_page_intro') }}
                </p>
            </div>
            <div class="col-lg-4 mt-3 mt-lg-0">
                <div class="app-listing-page__top-actions">
                    <button
                        v-if="this.$can('store_leave-types')"
                        type="button"
                        class="btn btn-primary btn-with-shadow"
                        data-toggle="modal"
                        @click="openAddEditModal">
                        {{ this.$t('add') }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click="refreshTable"
                    >
                        {{ this.$t('refresh') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="card card-with-shadow border-0 mb-4">
            <div class="card-body app-listing-page__table-card-body">
                <app-table :id="tableId" :options="options" @action="getListAction" />
            </div>
        </div>

        <leave-type-add-edit-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="leave-type-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import * as actions from "../../../Config/ApiUrl";
import { status } from '../../../Mixins/FilterMixin';

export default {
    extends: CoreLibrary,
    mixins: [status],
    name: "AppLeaveTypes",
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'leave-types-table',
            rowData: {},
            options: {
                name: 'AppLeaveTypes',
                url: actions.LEAVE_TYPE,
                showHeader: true,
                tableShadow: false,
                enableHighlights: true,
                enableRowSelect: false,
                enableSaveFilter: true,
                columns: [
                    {
                        title: this.$t('code'),
                        type: 'text',
                        key: 'code',
                    },
                    {
                        title: this.$t('name'),
                        type: 'text',
                        key: 'name',
                    },
                    {
                        title: this.$t('is_paid'),
                        type: 'custom-html',
                        key: 'is_paid',
                        isVisible: true,
                        modifier: (isPaid => {
                            switch (isPaid) {
                                case 1:
                                    return `<span class="badge badge-pill badge-success">${this.$t('paid')}</span>`;
                                case 0:
                                    return `<span class="badge badge-pill badge-warning">${this.$t('unpaid')}</span>`;
                                default:
                                    return '-';
                            }
                        })
                    },
                    {
                        title: this.$t('max_days_per_year'),
                        type: 'text',
                        key: 'max_days_per_year',
                    },
                    {
                        title: this.$t('description'),
                        type: 'text',
                        key: 'description',
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        component: 'leave-type-add-modal',
                        modalId: 'leave-type-add-edit-modal',
                        modifier: (row) => {
                            return this.$can('update_leave-types') && this.canAlterLeaveType(row.code);
                        },

                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'user-delete',
                        modifier: (row) => {
                            return this.$can('delete_leave-types') && this.canAlterLeaveType(row.code);
                        },
                    }
                ],
                filters: [
                    {
                        "title": this.$t('created_at'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                ],
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 8,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    created() {
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        refreshTable() {
            this.$hub.$emit('reload-' + this.tableId);
        },

        canAlterLeaveType(code) {
            const codes = ['P','PN','AA','M','CA','CC','S','F', 'CS']
            return !codes.includes(code);
        },

        /**
         * for close add edit modal 
         */
        closeAddEditModal() {
            this.isAddEditModalActive = false;
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('delete')) {
                this.canAlterLeaveType(rowData.code) ? this.openDeleteModal() : null;
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.LEAVE_TYPE}/${rowData.id}`;
                this.canAlterLeaveType(rowData.code) ? this.openAddEditModal() : null;
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.LEAVE_TYPE}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#leave-type-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
    },
}
</script>
